var exports = {
  "kL": "WebhookListItem.module__container___dUpFZ2",
  "aY": "WebhookListItem.module__headerButton___dUpFZ2",
  "kb": "WebhookListItem.module__left___dUpFZ2",
  "Jb": "WebhookListItem.module__avatarLarge___dUpFZ2",
  "fI": "WebhookListItem.module__textBlock___dUpFZ2",
  "$": "WebhookListItem.module__titleRow___dUpFZ2",
  "UU": "WebhookListItem.module__name___dUpFZ2",
  "ML": "WebhookListItem.module__channelTag___dUpFZ2",
  "KW": "WebhookListItem.module__metaRow___dUpFZ2",
  "K9": "WebhookListItem.module__channelTagMobile___dUpFZ2",
  "ai": "WebhookListItem.module__chevron___dUpFZ2",
  "hg": "WebhookListItem.module__chevronExpanded___dUpFZ2",
  "zH": "WebhookListItem.module__details___dUpFZ2",
  "J1": "WebhookListItem.module__detailsRow___dUpFZ2",
  "Mc": "WebhookListItem.module__avatarColumn___dUpFZ2",
  "Pf": "WebhookListItem.module__label___dUpFZ2",
  "_Q": "WebhookListItem.module__avatarPreview___dUpFZ2",
  "OA": "WebhookListItem.module__fields___dUpFZ2",
  "EN": "WebhookListItem.module__fieldsRow___dUpFZ2",
  "ch": "WebhookListItem.module__fieldGrow___dUpFZ2",
  "o1": "WebhookListItem.module__actions___dUpFZ2",
  "Dy": "WebhookListItem.module__avatarActions___dUpFZ2",
  "B": "WebhookListItem.module__urlWrapper___dUpFZ2",
  "UQ": "WebhookListItem.module__monoInput___dUpFZ2",
  "Bx": "WebhookListItem.module__iconSmall___dUpFZ2",
  "xv": "WebhookListItem.module__truncate___dUpFZ2",
};

module.exports = exports;
